import { Button } from 'react-bootstrap'

interface SortableHeaderProps {
  title: string
  isActive: boolean
  sortOrder: 'asc' | 'desc'
  onClick: () => void
}

const SortableHeader: React.FC<SortableHeaderProps> = ({
  title,
  isActive,
  sortOrder,
  onClick,
}) => {
  const getSortIcon = () => {
    if (!isActive) {
      return '↕'
    }

    return sortOrder === 'asc' ? '↑' : '↓'
  }

  return (
    <Button
      variant="link"
      onClick={onClick}
      className="p-0 text-decoration-none text-dark fw-bold"
    >
      {title} {getSortIcon()}
    </Button>
  )
}

export default SortableHeader
